import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  CursorQuery,
  Namespace,
} from '@wix/ambassador-legends-persona-v1-chat/types';
import { queryChatMessages } from '@wix/ambassador-legends-persona-v1-chat/http';

import { request } from '../../../../services/request';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';

export default async function (
  flowAPI: ControllerFlowAPI,
  chatId: string,
  store: any,
) {
  const messages = await queryAllChatMessages(flowAPI, chatId);

  store.messages = [...messages];

  flowAPI.controllerConfig.setProps({
    messages,
  });
}

// TODO: implement infinity scroll instead of fetching all messages at once
async function queryAllChatMessages(
  flowAPI: ControllerFlowAPI,
  chatId: string,
) {
  let messages = [];
  let hasNext = false;
  let next: string | null = null;

  do {
    try {
      const query: CursorQuery = {
        cursorPaging: {
          limit: 100,
          cursor: next,
        },
      };

      const response = await request({
        flowAPI,
        options: queryChatMessages({
          chatId,
          namespace: Namespace.EDUCATION,
          query,
        }),
        errorOptions: {
          errorCodesMap: { applicationError: {} },
        },
      });

      messages = [...messages, ...(response.data.chatMessages || [])];

      hasNext = response.data.pagingMetadata?.hasNext;
      next = response.data.pagingMetadata?.cursors?.next;
    } catch (error) {
      const resolvedError = flowAPI.errorHandler.getResolvedError(error);

      handleError({
        error,
        resolvedError,
        context: 'GetChatMessages',
        preventErrorMonitorReport: !shouldReportErrorMonitor(error),
      });

      hasNext = false;
      next = null;
    }
  } while (hasNext);

  return messages;
}
